import { app } from '../../../../app';

app.component('portsUsedBySaaspassProducts', {
    templateUrl: require('./ports-used-by-saaspass-products.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/ports-used-by-saaspass-products/ports-used-by-saaspass-products.component.js